export const formatYen = (value) => {
  if (value === null || value === undefined || isNaN(Number(value))) return '';
  try {
    return Number(value).toLocaleString('ja-JP') + '円';
  } catch (_) {
    return `${value}円`;
  }
};

export default { formatYen };

